module.exports = __webpack_public_path__ + "a8525f748d4b0fa5c1109f7afee8ef18.png";